(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ae-cart-enhancements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ae-cart-recommendations')) {
    let ranks = {};
    try { ranks = JSON.parse(sessionStorage.getItem('ae-cart-rec-ranks-v2') || '{}'); } catch (_) {}
    customElements.define('ae-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected) return;
          const rows = Array.from(this.querySelectorAll('ae-cart-recommendation'));
          rows.forEach(row => { const id = row.dataset.productId; if (typeof ranks[id] !== 'number') ranks[id] = Math.random(); });
          rows.sort((a,b) => ranks[a.dataset.productId] - ranks[b.dataset.productId]);
          rows.forEach((row,index) => { row.hidden = index >= 5; row.dataset.aeShow = String(index < 5); row.style.order = index; row.dataset.aeLast = String(index === Math.min(rows.length, 5) - 1); });
          try { sessionStorage.setItem('ae-cart-rec-ranks-v2', JSON.stringify(ranks)); } catch (_) {}
        });
      }
    });
  }

  if (!customElements.get('ae-cart-recommendation')) {
    customElements.define('ae-cart-recommendation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const select = this.querySelector('select[name="id"]');
        const add = this.querySelector('[name="add"]');
        select?.addEventListener('change', () => {
          add.disabled = !select.value;
          const price = select.selectedOptions[0]?.dataset.price;
          if (price) this.querySelector('.ae-rec-price').textContent = price;
          const compare = this.querySelector('.ae-rec-compare');
          compare.textContent = select.selectedOptions[0]?.dataset.compare || '';
          compare.hidden = !compare.textContent;
          const saving = this.querySelector('.ae-rec-saving');
          saving.textContent = select.selectedOptions[0]?.dataset.saving || '';
          saving.hidden = !saving.textContent;
          const option = select.selectedOptions[0];
          const image = this.querySelector('.ae-rec-image img');
          const source = option?.dataset.image;
          if (image && source) {
            if (image.getAttribute('src') !== source) {
              image.removeAttribute('srcset');
              image.src = source;
            }
            image.alt = option.dataset.imageAlt || '';
          }
          if (option?.dataset.url) {
            this.querySelectorAll('.ae-rec-image, .ae-rec-title').forEach(link => { link.href = option.dataset.url; });
          }
          this.querySelector('.ae-rec-error').hidden = true;
        }, {signal});
        this.addEventListener('cart:add:error', e => {
          const error = this.querySelector('.ae-rec-error');
          error.hidden = false;
          if (typeof e.detail?.error === 'string') error.textContent = e.detail.error;
        }, {signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  if (!window.aeDrawerEnhancements) {
    window.aeDrawerEnhancements = true;
    let scrollTop = null;
    let busy = false;
    let timer;
    const drawer = () => document.getElementById('CartDrawer');
    const start = () => {
      const d = drawer();
      if (!d) return;
      scrollTop = d.querySelector('[data-hdt-scroll-me]')?.scrollTop ?? 0;
      busy = true;
      clearTimeout(timer);
      const checkout = d.querySelector('[name="checkout"]');
      if (checkout) { checkout.disabled = true; checkout.setAttribute('aria-busy','true'); }
      timer = setTimeout(finish, 15000);
    };
    const finish = () => {
      busy = false;
      clearTimeout(timer);
      const checkout = drawer()?.querySelector('[name="checkout"]');
      if (checkout) { checkout.disabled = false; checkout.removeAttribute('aria-busy'); }
    };
    document.addEventListener('submit', e => {
      const d = e.target.closest?.('#CartDrawer');
      if (!d) return;
      if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (e.target.matches('.ae-rec-form') && e.target.checkValidity()) start();
    }, true);
    document.addEventListener('change', e => {
      const target = e.detail?.target || e.target;
      if (target?.closest?.('#CartDrawer') && (target.hasAttribute('will-change-cart') || target.matches('wrapp-remove-item-oncart'))) start();
    }, true);
    document.addEventListener('cart:drawer:render', () => {
      if (scrollTop !== null) {
        const scroller = drawer()?.querySelector('[data-hdt-scroll-me]');
        if (scroller) scroller.scrollTop = scrollTop;
      }
      finish();
    });
    document.addEventListener('cart:change', () => { finish(); scrollTop = null; });
    document.addEventListener('cart:add:error', finish);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aeeyaa-atc-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.documentElement;

  if (root.dataset.aeeyaaAtcMotionInitialized === 'true') {
    return;
  }

  root.dataset.aeeyaaAtcMotionInitialized = 'true';

  const selector = '#MainContent .hdt-main-product-form .hdt-product-form__submit[name="add"]';
  const boundButtons = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const bindButton = (button) => {
    if (boundButtons.has(button)) {
      return;
    }

    boundButtons.add(button);

    let isVisible = false;
    let readyTimer;

    const playReady = () => {
      window.clearTimeout(readyTimer);

      if (
        reduceMotion.matches ||
        !isVisible ||
        button.disabled ||
        button.getAttribute('aria-busy') === 'true' ||
        button.dataset.aeeyaaAtcAnimated === 'true'
      ) {
        return;
      }

      readyTimer = window.setTimeout(() => {
        if (
          !isVisible ||
          button.disabled ||
          button.getAttribute('aria-busy') === 'true' ||
          button.dataset.aeeyaaAtcAnimated === 'true'
        ) {
          return;
        }

        button.dataset.aeeyaaAtcAnimated = 'true';
        button.classList.add('aeeyaa-atc-ready');
      }, 220);
    };

    button.addEventListener('animationend', (event) => {
      if (event.animationName === 'aeeyaa-atc-ready') {
        button.classList.remove('aeeyaa-atc-ready');
      }

      if (event.animationName === 'aeeyaa-atc-success') {
        button.classList.remove('aeeyaa-atc-success');
      }
    });

    const formWrapper = button.closest('wrapp-hdt-pr-frm');

    formWrapper?.addEventListener('variant:add', () => {
      window.clearTimeout(readyTimer);
      button.dataset.aeeyaaAtcAnimated = 'true';
      button.classList.remove('aeeyaa-atc-ready');
      button.classList.add('aeeyaa-atc-success');

      window.setTimeout(() => {
        button.classList.remove('aeeyaa-atc-success');
      }, 700);
    });

    const buttonStateObserver = new MutationObserver(playReady);
    buttonStateObserver.observe(button, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-busy']
    });

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver((entries) => {
        isVisible = entries[0]?.isIntersecting === true && entries[0].intersectionRatio >= 0.72;

        if (isVisible) {
          playReady();
        } else {
          window.clearTimeout(readyTimer);
        }
      }, {
        threshold: [0.72]
      });

      visibilityObserver.observe(button);
    } else {
      isVisible = true;
      playReady();
    }
  };

  const bindAll = () => {
    document.querySelectorAll(selector).forEach(bindButton);
  };

  bindAll();

  const mainContent = document.getElementById('MainContent');

  if (mainContent) {
    const contentObserver = new MutationObserver(bindAll);
    contentObserver.observe(mainContent, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('shopify:section:load', bindAll);
})();
  } catch(e) { console.error(e); }
})();

})();
